import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Box, Section, Title } from "../../components/Core";
import HeaderBackground from "../../components/HeaderBackground";

const Hero = ({ title }) => {
  return (
    <>
      {/* <!-- Hero Area --> */}
      <HeaderBackground>
        <Section>
          <Container>
            <Row>
              <Col
                md="11"
                lg="9"
                className="order-lg-1"
                data-aos="fade-right"
                data-aos-duration="750"
                data-aos-delay="500"
                data-aos-once="true"
              >
                <Box py={[null, null, null, 5]} pr={5} pt={[4, null]}>
                  <Title variant="hero">
                    {title}
                  </Title>
                </Box>
              </Col>
            </Row>
          </Container>
        </Section>
      </HeaderBackground>
    </>
  );
};

export default Hero;
